import React, { useState, useEffect } from "react";
import Typewriter from "typewriter-effect";
// import videobg from "../videos/home.mp4";
import resumeFile from "../documents/resume.pdf";

const Home = ({ classicHeader, darkTheme, handleNavClick }) => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const imageSize = windowWidth >= 992 ? "450px" : "280px";

  const handleDownload = async () => {
    try {
      const response = await fetch(resumeFile);
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "Weichen_Zhang_Resume.pdf");
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Download failed:", error);
    }
  };

  return (
    <section id="home">
      <div className="hero-wrap">
        <div className="hero-mask opacity-8 bg-dark" />

        {/* ---------------image background------------------ */}
        <div
          className="hero-bg parallax"
          style={{ backgroundImage: 'url("images/intro-bg.jpg")' }}
        ></div>

        {/* -------------------video background---------------------- */}

        {/* <div className="player hero-bg parallax">
          <video
            src={videobg}
            autoPlay
            muted
            loop
            style={{ width: "100%", height: "100vh", objectFit: "cover" }}
          ></video>
        </div> */}

        <div className="hero-content section d-flex min-vh-100">
          <div className="container my-auto">
            <div className="row align-items-center flex-column-reverse flex-lg-row">
              {/* Left Column - Text Content */}
              <div className="col-lg-7 text-center text-lg-start">
                <p className="text-7 fw-500 text-white mb-2 mb-md-3">Welcome</p>
                <h2 className="text-16 fw-600 text-white mb-2 mb-md-3">
                  <Typewriter
                    options={{
                      strings: [
                        "I'm Weichen Zhang.",
                        "I'm an aspiring Software Engineer.",
                        "I'm an Undergraduate Researcher.",
                      ],
                      autoStart: true,
                      loop: true,
                    }}
                  />
                </h2>
                <p className="text-5 text-light mb-4">
                  based in San Francisco, CA.
                </p>
                <div className="d-flex justify-content-center justify-content-lg-start gap-3">
                  <a
                    href="#contact"
                    className="btn btn-outline-primary rounded-pill shadow-none smooth-scroll mt-2"
                    onClick={(e) => {
                      e.preventDefault();
                      handleNavClick("contact");
                    }}
                  >
                    Contact Me
                  </a>
                  <a
                    className="btn btn-outline-secondary rounded-pill shadow-none mt-2"
                    onClick={handleDownload}
                  >
                    Download Resume
                  </a>
                </div>
              </div>

              {/* Right Column - Profile Image */}
              <div className="col-lg-5 text-center mb-4 mb-lg-0">
                <div
                  className="profile-image"
                  style={{
                    width: imageSize,
                    height: imageSize,
                    margin: "0 auto",
                    borderRadius: "50%",
                    overflow: "hidden",
                    border: "4px solid rgba(255, 255, 255, 0.2)",
                    boxShadow: "0 0 20px rgba(0, 0, 0, 0.3)",
                  }}
                >
                  <img
                    src="images/profile.jpg"
                    alt="Profile"
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                      display: "block",
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
          <a
            href="#about"
            className="scroll-down-arrow text-white smooth-scroll"
            onClick={(e) => {
              e.preventDefault();
              handleNavClick("about");
            }}
          >
            <span className="animated">
              <i className="fa fa-chevron-down" />
            </span>
          </a>
        </div>
      </div>
    </section>
  );
};

export default Home;
